/**
 * Site-wide keyboard helpers: skip-link target, menu roving, details Esc.
 */
(function () {
    'use strict';

    function skipTarget() {
        return document.getElementById('site-main') ||
            document.getElementById('appaltimap-map') ||
            document.querySelector('.site-content') ||
            document.querySelector('main');
    }

    function initSkipLink() {
        var link = document.querySelector('.vg-skip-link');
        if (!link) return;
        link.addEventListener('click', function (e) {
            var target = skipTarget();
            if (!target) return;
            e.preventDefault();
            if (!target.hasAttribute('tabindex')) {
                target.setAttribute('tabindex', '-1');
            }
            target.focus({ preventScroll: false });
            target.scrollIntoView({ behavior: 'auto', block: 'start' });
        });
    }

    function menuItems(panel) {
        return Array.prototype.slice.call(
            panel.querySelectorAll('[role="menuitem"], .vg-tools-menu__item, .vg-account-menu__item, .vg-cp-export-menu__panel button')
        ).filter(function (el) {
            return !el.hidden && el.offsetParent !== null;
        });
    }

    function initRovingMenu(panel, toggleBtn) {
        if (!panel || panel.__vgA11yMenu) return;
        panel.__vgA11yMenu = true;

        panel.addEventListener('keydown', function (e) {
            if (panel.hidden) return;
            var items = menuItems(panel);
            if (!items.length) return;
            var idx = items.indexOf(document.activeElement);
            if (idx < 0 && document.activeElement === toggleBtn) idx = -1;

            if (e.key === 'ArrowDown' || e.key === 'Down') {
                e.preventDefault();
                items[(idx + 1 + items.length) % items.length].focus();
            } else if (e.key === 'ArrowUp' || e.key === 'Up') {
                e.preventDefault();
                items[(idx - 1 + items.length) % items.length].focus();
            } else if (e.key === 'Home') {
                e.preventDefault();
                items[0].focus();
            } else if (e.key === 'End') {
                e.preventDefault();
                items[items.length - 1].focus();
            } else if (e.key === 'Escape' || e.key === 'Esc') {
                e.preventDefault();
                panel.hidden = true;
                if (toggleBtn) {
                    toggleBtn.setAttribute('aria-expanded', 'false');
                    toggleBtn.focus();
                }
            }
        });
    }

    function initMenus() {
        document.querySelectorAll('[data-vg-tools-menu]').forEach(function (wrap) {
            initRovingMenu(
                wrap.querySelector('[data-vg-tools-panel]'),
                wrap.querySelector('[data-vg-tools-toggle]')
            );
        });

        document.querySelectorAll('.vg-account-menu').forEach(function (wrap) {
            initRovingMenu(
                wrap.querySelector('.vg-account-menu__panel'),
                wrap.querySelector('summary')
            );
        });

        document.querySelectorAll('[data-cp-export-menu]').forEach(function (wrap) {
            initRovingMenu(
                wrap.querySelector('.vg-cp-export-menu__panel'),
                wrap.querySelector('summary')
            );
        });
    }

    function initDetailsEsc() {
        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Escape' && e.key !== 'Esc') return;
            var openDetails = document.querySelector('details[open]');
            if (!openDetails) return;
            if (openDetails.closest('.vg-kanban-modal, .vg-bug-report-modal, .vg-a11y-modal, .vg-ai-modal')) return;
            var summary = openDetails.querySelector('summary');
            openDetails.removeAttribute('open');
            if (summary) summary.focus();
        });
    }

    function init() {
        initSkipLink();
        initMenus();
        initDetailsEsc();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.VgA11yKeyboard = {
        skipTarget: skipTarget,
        initMenus: initMenus
    };
})();
